import getCurrentDomain from '../../utils/getCurrentDomain'

const cookieOpts = () => {
  const domain = `.${getCurrentDomain()}`
  const secure = window.location.protocol === 'https:'
  return {
    domain,
    expires: 1,
    secure,
    sameSite: secure ? 'Strict' : 'Lax',
  }
}

export default cookieOpts
